// Shared export file-naming (the ADR-045 §8 doctrine): `{base}_{project-slug}_{YYYY-MM-DD}`.
//
// The backend names every export and template it sends with it (`Content-Disposition`,
// the DAY read in the export's zone — ADR-082 §8) and the browser keeps that name;
// the frontend's own date-less stem (`lib/exportFilename.ts`, the slug only) is the
// fallback for a body the header did not name. The file EXTENSION is the caller's
// to append: the backend adds `.{format}`; the frontend names its blob flow
// separately, so this stem is extension-free.
/** Project display name → URL-safe slug; `'project'` fallback for a non-Latin name
 *  (the server's day then identifies the file). */
export function projectSlug(projectName) {
    return projectName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'project';
}
/** The shared filename stem `{base}_{project-slug}_{YYYY-MM-DD}` (no extension).
 *  `base` is the plural entity word the consumer picks ('users', 'roles'); `day`
 *  is the export zone's calendar day (ADR-082 §8) — the caller reads it in its
 *  zone, so the name says the day the reader is in. */
export function exportFilename(base, projectName, day) {
    return `${base}_${projectSlug(projectName)}_${day}`;
}
